import { render, staticRenderFns } from "./WindowImpacts.vue?vue&type=template&id=0c58adc3&scoped=true"
import script from "./WindowImpacts.vue?vue&type=script&lang=ts"
export * from "./WindowImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58adc3",
  null
  
)

export default component.exports